const SET_DEVICE = 'SET_DEVICE'
const SET_FISCAL_YEAR = 'SET_FISCAL_YEAR'
const SET_POPUP_MSG_MODEL = 'SET_POPUP_MSG_MODEL'

export { SET_DEVICE, SET_FISCAL_YEAR, SET_POPUP_MSG_MODEL }
